//// filepath: c:\Users\cicer\Projeto Trabalho\csplus-school--reactjs\src\views\pages\modal\ModalUserPresence.jsx
import React from "react";
import { Modal, Card, CardHeader, CardBody, Table } from "reactstrap";
import api from "./../../../Api.js";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { connect } from "react-redux";

class ModalUserPresence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      presences: [],
      load: false,
      error: null
    };
  }

  componentDidMount() {
    this.getUserPresences();
  }

  async getUserPresences() {
    try {
      this.setState({ load: false });
      const classroom = this.props.classroom;
      const userId = this.props.userId;

      if (classroom) {
        const response = await api.getUserPresence(classroom, userId);
        this.setState({ presences: response.data || [], load: true });
        return;
      }

      // If no classroom provided, try to fetch all classrooms for the company and aggregate
      const company = this.props.company;
      if (!company) {
        // nothing to query
        this.setState({ presences: [], load: true });
        return;
      }

      // Try to fetch company classrooms and then presence per classroom
      const clsRes = await api.getClassRoomCompany(company).catch(() => null);
      const classrooms = Array.isArray(clsRes?.data) ? clsRes.data : [];
      const presencePromises = classrooms.map(c => api.getUserPresence(c.id, userId).catch(() => ({ data: [] })));
      const results = await Promise.all(presencePromises);
      // flatten and include classroom id if available
      const combined = [];
      results.forEach((r, i) => {
        const rows = Array.isArray(r.data) ? r.data : [];
        rows.forEach(row => combined.push({ ...row, classroom: classrooms[i]?.id || null }));
      });

      // deduplicate by date (keep first non-null presence when duplicates) and sort desc
      const byDate = {};
      combined.forEach(r => {
        const key = r.date || r.presenceDate || r.createdAt || '';
        if (!key) return;
        if (!byDate[key]) byDate[key] = r;
      });
      const final = Object.keys(byDate)
        .sort((a, b) => (a < b ? 1 : -1))
        .map(d => byDate[d]);

      this.setState({ presences: final, load: true });
    } catch (err) {
      this.setState({
        load: true,
        error: err.response?.data?.msg || (this.props.translate['erro_ao_buscar_presencas'] || "Erro ao buscar presenças.")
      });
    }
  }

  getUnitName(unitId) {
    if (!unitId) return null;
    const found = this.props.units?.find((u) => parseInt(u.id) === parseInt(unitId));
    return found ? found.name : null;
  }
  
  render() {
    return (
      <Modal isOpen={true} className="modal-dialog-centered">
        <Card className="bg-secondary border-0">
          <CardHeader>
            <h5>{this.props.translate['minhas_presencas'] || 'Minhas Presenças'}</h5>
            <button
              type="button"
              className="close"
              onClick={() => this.props.close()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </CardHeader>
          <CardBody>
            {!this.state.load && (
              <div style={{ textAlign: "center" }}>
                <ClipLoader color="#000" loading={true} size={24} />
              </div>
            )}
            {this.state.load && this.state.error && (
              <div className="alert alert-danger">{this.state.error}</div>
            )}
            {this.state.load && !this.state.error && (
              <Table className="table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: 140 }}>{this.props.translate['data'] || 'Data'}</th>
                    <th style={{ width: 120 }}>{this.props.translate['dia'] || 'Dia'}</th>
                    <th>{this.props.translate['presenca'] || 'Presença'}</th>
                    <th>{this.props.translate['unidade'] || 'Unidade'}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.presences.length === 0 && (
                    <tr>
                      <td colSpan="3" className="text-center">
                        {this.props.translate['nenhuma_presenca_encontrada'] || 'Nenhuma presença encontrada'}
                      </td>
                    </tr>
                  )}
                  {this.state.presences.map((row, idx) => {
                    const unitName = this.getUnitName(row.unit);
                    const date = row.date || row.presenceDate || row.createdAt;
                    const m = moment(date, "YYYY-MM-DD");
                    const dayNameRaw = m.locale('pt-br').format('dddd');
                    const dayName = dayNameRaw ? dayNameRaw.charAt(0).toUpperCase() + dayNameRaw.slice(1) : '';
                    return (
                      <tr key={idx}>
                        <td>{m.isValid() ? m.format('DD/MM/YYYY') : (date || '')}</td>
                        <td>{m.isValid() ? dayName : ''}</td>
                        <td>{row.presence === "presente" ? (this.props.translate['presente'] || 'Presente') : (this.props.translate['falta'] || 'Falta')}</td>
                        <td>{unitName || (this.props.translate['sem_unidade'] || 'Sem unidade')}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Modal>
    );
  }
}

export default connect((state) => state)(ModalUserPresence);